import { useState } from "react";
import { useSelector } from "react-redux";
import SearchResults2 from "./SearchResults2";
// import { useGetOrderedProductsQuery } from "../store/apiSlice";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";

function JobsCenter() {
  const location = useLocation();
  const filters = location.state?.selectedFilters || [];
  const [q, setQ] = useState({ userId: -1, sort: filters.length > 0 ? 'date' : '' })

  const userInfo = useSelector((state) => state.auth.userInfo);
  if (userInfo.employer_id) {
    setQ()
  }

  return (
    <div className=" flex  flex-col px-6  gap-8 mt-4 w-full">
      <p className="text-3xl font-bold text-black shadow-xl px-2 pb-4 mt-4 mb-6">Our Jobs</p>
      <SearchResults2 q={q} filters={filters} />
    </div>
  );
}
export default JobsCenter;
